import axios from "axios";
import { getToken } from "context/AuthContext";
const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const GET = async (url, isAuthorized) => {
  try {
    const headers = {};
    if (isAuthorized) {
      const token = getToken();
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await axiosInstance.get(url, { headers });
    return {
      isSuccess: true,
      message: response.data.message || "Success!",
      data: response.data.data,
    };
  } catch (error) {
    return handleError(error);
  }
};

export const POST = async (url, data, isAuthorized, timeout) => {
  try {
    const headers = {};
    if (isAuthorized) {
      const token = getToken();
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await axiosInstance.post(url, data, {
      headers,
      ...(timeout ? { timeout } : {}),
    });
    return {
      isSuccess: true,
      message: response.data.message || "Success!",
      data: response.data.data,
    };
  } catch (error) {
    return handleError(error);
  }
};

export const POST_PARTNER = async (url, data, headers = {}) => {
  try {
    const response = await axiosInstance.post(url, data, { headers });
    return {
      isSuccess: true,
      message: response.data.message || "Success!",
      data: response.data.data,
    };
  } catch (error) {
    return handleError(error);
  }
};

export const PUT = async (url, data, isAuthorized) => {
  try {
    const headers = {};
    if (isAuthorized) {
      const token = getToken();
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await axiosInstance.put(url, data, { headers });
    return {
      isSuccess: true,
      message: response.data.message || "Success!",
      data: response.data.data,
    };
  } catch (error) {
    return handleError(error);
  }
};

export const DELETE = async (url, isAuthorized) => {
  const headers = {};
  if (isAuthorized) {
    const token = getToken();
    headers["Authorization"] = `Bearer ${token}`;
  }
  try {
    const response = await axiosInstance.delete(url, { headers });
    return {
      isSuccess: true,
      message: response.data.message || "Success!",
      data: response.data,
    };
  } catch (error) {
    return handleError(error);
  }
};

const isIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("permissions");
  localStorage.removeItem("me");

  if (!isIframe()) {
    window.location.href = "/login";
    window.location.reload();
  }
};

const handleError = (error) => {
  if (error?.response?.status === 400) {
    return {
      isSuccess: false,
      message: error?.response?.data.message || "Bad Request!",
    };
  }
  if (error?.response?.status === 401) {
    handleLogout();
    return {
      isSuccess: false,
      message: error?.response.data.message || "Unauthorized!",
    };
  }
  if (error?.response?.status === 403) {
    if (!isIframe()) {
      window.location.href = "/403";
    }
    return {
      isSuccess: false,
      status: 403,
      message: error.response.data.message || "Access Denied!",
    };
  }
  if (error?.code === "ECONNABORTED") {
    return {
      isSuccess: false,
      message: "This is taking too long. Please try again.",
    };
  }
  return {
    isSuccess: false,
    message:
      error?.response?.data?.message || error?.message || "Bad Request!",
  };
};
